"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsSearchMap = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLeaflet = require("react-leaflet");
var _leafletGeosearch = require("leaflet-geosearch");
require("leaflet/dist/leaflet.css");
require("leaflet-geosearch/dist/geosearch.css");
var _Position = require("../../constants/Position");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Component that displays a map with geolocation search control.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {Function} props.onSelectLocation - Function called when a location is selected.
 * @returns {JSX.Element} Map component with search control.
 */
const DmsSearchMap = _ref => {
  let {
    onSelectLocation,
    height = "100vh",
    width = "100vw"
  } = _ref;
  const [searchControl, setSearchControl] = (0, _react.useState)(null);
  const MapComponent = () => {
    const map = (0, _reactLeaflet.useMap)();
    if (!searchControl) {
      const provider = new _leafletGeosearch.OpenStreetMapProvider();
      const control = new _leafletGeosearch.GeoSearchControl({
        provider,
        style: 'bar',
        autoComplete: true,
        showMarker: true,
        showPopup: false,
        updateMap: true,
        marker: {
          icon: _Position.blueMarkerIcon,
          draggable: false
        }
      });
      map.on('geosearch/showlocation', selectedHandler);
      map.addControl(control);
      setSearchControl(control);
    }
    return null;
  };
  const selectedHandler = result => onSelectLocation(result);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactLeaflet.MapContainer, {
    center: [_Position.defaultPosition.lat, _Position.defaultPosition.lng],
    zoom: _Position.defaultPosition.zoom,
    style: {
      height: height,
      width: width
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLeaflet.TileLayer, {
    url: _Position.tileLayer.url,
    attribution: _Position.tileLayer.attribution,
    maxZoom: _Position.tileLayer.maxZoom,
    accessToken: _Position.tileLayer.accessToken
  }), /*#__PURE__*/_react.default.createElement(MapComponent, null)));
};
exports.DmsSearchMap = DmsSearchMap;
DmsSearchMap.propTypes = {
  onSelectLocation: _propTypes.default.func.isRequired
};